/** Only allow returning to an org invite magic-link path. */
export function safeInviteReturn(raw) {
  if (!raw || typeof raw !== "string") return null;
  let path = raw.trim();
  if (!path.startsWith("/")) path = `/${path}`;
  const pathname = path.split("?")[0];
  if (!/^\/invite\/[A-Za-z0-9_-]{16,128}$/.test(pathname)) return null;
  return pathname;
}

/** Post-login return for invite links or marketplace install bridge. */
export function safePostLoginReturn(raw) {
  const invite = safeInviteReturn(raw);
  if (invite) return invite;
  if (!raw || typeof raw !== "string") return null;
  let path = raw.trim();
  if (!path.startsWith("/")) path = `/${path}`;
  try {
    const u = new URL(path, "https://circa.local");
    if (u.pathname !== "/apps/install") return null;
    const pack = String(u.searchParams.get("pack") || "").trim();
    if (pack && !/^[a-z0-9][a-z0-9_-]{0,79}$/i.test(pack)) return null;
    return pack
      ? `/apps/install?pack=${encodeURIComponent(pack.toLowerCase())}`
      : "/apps/install";
  } catch {
    return null;
  }
}

export function withInviteReturn(path, returnPath) {
  const safe = safePostLoginReturn(returnPath) || safeInviteReturn(returnPath);
  if (!safe) return path;
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}return=${encodeURIComponent(safe)}`;
}
